import TextUtil from "../../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import KeyDecision from "../../key-decisions/model/KeyDecision";

export default class HubKeyDecisionListItemMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;

        /** @type {KeyDecision} */
        //this._keyDecision = this.getCustomData().keyDecision;
        this._keyDecision = null;

        this._handleRolloverBound = this._handleRollover.bind(this);
        this._handleRolloutBound = this._handleRollout.bind(this);

        this._isAvailable = false;
    }

    initialize() {
        super.initialize();
        this.disable();
    }

    isAvailable() {
        return this._isAvailable;
    }

    hasKeyDecision() {
        return this._keyDecision !== null;
    }

    getKeyDecision() {
        return this._keyDecision;
    }

    initializeWithKeyDecision(keyDecision) {
        this._keyDecision = keyDecision;
        this._button = this.createButton(this._target.button, this._handleButton.bind(this));
        this._button.addEventListener('rollover', this._handleRolloverBound);
        this._button.addEventListener('rollout', this._handleRolloutBound);

        this._target.panel.alpha = 0;
        this._target.panel.actionNeededTextField.initialY = this._target.panel.actionNeededTextField.y;
        this._target.panel.actionNeededTextField.initialBounds = this._target.panel.actionNeededTextField.getBounds();
        this._target.panel.actionNeededTextField.text = this._languagePack.getText(this._keyDecision.actionNeededLpKey);
        TextUtil.centerTextVertically(this._target.panel.actionNeededTextField, this._target.panel.actionNeededTextField.initialY, this._target.panel.actionNeededTextField.initialBounds.height);
    }

    disable() {
        this._isAvailable = false;
        this._target.gotoAndStop(2);
    }

    availableUnseen() {
        this._isAvailable = true;
        this._target.gotoAndStop(0);
    }

    availableSeen() {
        this._isAvailable = true;
        this._target.gotoAndStop(1);
    }

    performed() {
        this._isAvailable = false;
        this.destroyButton();
        this._target.gotoAndStop(3);
    }

    destroyButton() {
        this._button.removeEventListener('rollover', this._handleRolloverBound);
        this._button.removeEventListener('rollout', this._handleRolloutBound);
        this._button.destroy();
        this._button = null;
    }

    destroy() {
        if (this._button !== null) {
            this.destroyButton();
        }
        super.destroy();
    }

    _handleButton() {
        const keyDecisionInteractionEvent = new KeyDecisionInteractionEvent(KeyDecisionInteractionEvent.REQUEST_KEY_DECISION, this._keyDecision);
        this._dispatcher.dispatch(keyDecisionInteractionEvent.type, { data: keyDecisionInteractionEvent });
        this.availableSeen();
    }

    _handleRollover() {
        createjs.Tween.get(this._target.panel, { override: true })
            .to({ alpha: 1 }, 250, createjs.Ease.sineInOut);
    }

    _handleRollout() {
        createjs.Tween.get(this._target.panel, { override: true })
            .to({ alpha: 0 }, 250, createjs.Ease.sineInOut);
    }

    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}